import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import GlobalMixins from "./mixins/GlobalMixins";
import GlobalMixinsDiscovery from "./mixins/GlobalMixinsDiscovery";
import vuetify from "./plugins/vuetify";
import GoogleLogin from "vue-google-login";
import * as VueGoogleMaps from "vue2-google-maps";
import UUID from "vue-uuid";
import VueGtag from 'vue-gtag'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VCalendar from 'v-calendar';


Vue.config.productionTip = false;

// GLOBAL MIXINS
Vue.mixin(GlobalMixins);


Vue.component("login-with-google", GoogleLogin);

//Vue2 google map
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDsE8uoWM9VUeJYs90H4-6whsIYgvTfCuI",
        libraries: "places", // necessary for places input
    },
});

//Lodash 
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

// UUID GENERATOR
Vue.use(UUID);

//VueGtag
Vue.use(VueGtag, {
  config: { id: 'G-70QCKLEYEJ' }
});
// CHART JS
Vue.use(Chartkick.use(Chart))

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

// EVENT BUS
export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
